export function retry({
  times = 5,
  every = 1000,
  condition,
  operation,
}: {
  times: number;
  every: number;
  condition: () => boolean;
  operation: () => void;
}) {
  if (condition()) {
    operation();
  } else if (times > 0) {
    setTimeout(() => {
      retry({ times: times - 1, every, condition, operation });
    }, every);
  }
}
